import React, { useState, useEffect } from "react";
import TextInput from "../../components/Reusable/TextInput";
import SelectInput from "../../components/Reusable/SelectInput";
import DateInput from "../../components/Reusable/DateInput";
import {
  useGetAllEmployeesPaginated,
  useGetAllJobGrades,
} from "../../hooks/useUsers";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import CheckboxInput from "../../components/Reusable/CheckboxInput";
import SelectableItemInput from "../../components/Reusable/SelectableItemInput";
import WeeklyShiftSchedule from "../../components/Reusable/WeeklyShiftSchedule";
import {
  useCreateShift,
  useGetShiftById,
  useUpdateShift,
} from "../../hooks/useShiftSchedules";

function AddShiftScheduleLayout() {
  const [isEditUser, setIsEditUser] = useState(false);
  const [editUserID, setEditUserID] = useState(null);

  const [editedFields, setEditedFields] = useState({});

  const createShift = useCreateShift();
  const updateShift = useUpdateShift();

  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data: _shiftData,
    isLoading: _shiftDataIsLoading,
    isError: _shiftDataIsError,
  } = useGetShiftById(id);

  useEffect(() => {
    if (id) {
      setIsEditUser(true);
      setEditUserID(id);
    }
  }, []);

  useEffect(() => {
    if (_shiftData?.success && _shiftData?.data) {
      const record = {
        ..._shiftData.data,
        Days: _shiftData.data?.ShiftSchedules,
      };

      setShiftSchedule(record);
      console.log("record: ", record);
    }
  }, [_shiftData]);

  const handleEditedChange = (field, value) => {
    if (!isEditUser) return;

    setEditedFields((prev) => {
      if (field !== "Days") {
        return { ...prev, [field]: value };
      }

      const prevDays = prev.Days || [];

      const exists = prevDays.find((d) => d.WorkingDays === value.WorkingDays);

      const updatedDays = exists
        ? prevDays.map((d) =>
            d.WorkingDays === value.WorkingDays ? { ...d, ...value } : d
          )
        : [...prevDays, value];

      return {
        ...prev,
        Days: updatedDays,
      };
    });
  };

  const handleSubmitShiftSchedule = async () => {
    if (isEditUser) {
      updateShift.mutate(
        { id, payload: editedFields },
        {
          onSuccess: (data) => {
            toast.success(data.message);
            navigate("/ShiftSchedule");
          },
        }
      );
    } else {
      createShift.mutate(shiftSchedule, {
        onSuccess: async (data) => {
          if (data.success) {
            toast.success(data.message);
            navigate("/ShiftSchedule");
          }
        },
      });
    }
  };
  const isSubmitDisabled = isEditUser && Object.keys(editedFields).length === 0;

  const [shiftSchedule, setShiftSchedule] = useState({
    Name: "",
    Description: "",
    Days: [
      {
        IsRestDay: false,
        StartTime: "",
        EndTime: "",
        WorkingDays: "Monday",
        BreakStartTime: "",
        BreakEndTime: "",
        BreakDurationMinutes: 0,
      },
      {
        IsRestDay: false,
        StartTime: "",
        EndTime: "",
        WorkingDays: "Tuesday",
        BreakStartTime: "",
        BreakEndTime: "",
        BreakDurationMinutes: 0,
      },
      {
        IsRestDay: false,
        StartTime: "",
        EndTime: "",
        WorkingDays: "Wednesday",
        BreakStartTime: "",
        BreakEndTime: "",
        BreakDurationMinutes: 0,
      },
      {
        IsRestDay: false,
        StartTime: "",
        EndTime: "",
        BreakStartTime: "",
        WorkingDays: "Thursday",
        BreakEndTime: "",
        BreakDurationMinutes: 0,
      },
      {
        IsRestDay: false,
        StartTime: "",
        EndTime: "",
        WorkingDays: "Friday",
        BreakStartTime: "",
        BreakEndTime: "",
        BreakDurationMinutes: 0,
      },
      {
        WorkingDays: "Saturday",
        IsRestDay: true,
      },
      {
        WorkingDays: "Sunday",
        IsRestDay: true,
      },
    ],
  });

  return (
    <div className="add-user-page">
      <div className="form-container">
        <h2>{isEditUser ? "Edit" : "Add"} Shift Schedule</h2>

        <form className="add-user-form">
          {/* ================= SHIFT SCHEDULE ================= */}
          <section>
            <WeeklyShiftSchedule
              value={shiftSchedule}
              onChange={setShiftSchedule}
              handleEditedChange={handleEditedChange}
            />
          </section>

          {/* ================= ACTIONS ================= */}
          <div className="form-actions">
            <button
              type="button"
              disabled={isSubmitDisabled}
              onClick={handleSubmitShiftSchedule}
            >
              Submit Shift Schedule
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddShiftScheduleLayout;
